<script>
    // ═══ ПРЕДЛОЖЕНИЕ ИГРОКА (всплывает снизу) ═══
    // Обмен, покупка, лечение, приглашение — всё, что требует ответа Y/N.
    // Было: белая картинка-заглушка, текст капсом и голая полоска. Стало —
    // панель в стиле худа: иконка по типу предложения, заголовок, читаемый
    // текст, подсказки клавиш и полоса оставшегося времени.
    import { fly } from 'svelte/transition';

    export let visible1 = false;
    export let subTitle1 = '';
    export let title1 = '';
    export let desc1 = '';

    // сколько секунд висит предложение (геймод даёт 10 с)
    const LIFE = 10;
    let left = LIFE;
    let timer = null;

    $: show = visible1 && subTitle1 === 'Предложение';

    // при каждом новом предложении запускаем отсчёт заново
    $: if (show) {
        left = LIFE;
        if (timer) clearInterval(timer);
        timer = setInterval(() => {
            left = Math.max(0, left - 0.1);
            if (left <= 0 && timer) { clearInterval(timer); timer = null; }
        }, 100);
    } else if (timer) {
        clearInterval(timer);
        timer = null;
    }

    // иконка по смыслу заголовка: обмен, покупка, лечение, приглашение
    const ICONS = {
        trade: '<path d="M4 8h13l-3-3"/><path d="M20 16H7l3 3"/>',
        buy: '<path d="M6 7h13l-1.5 9h-10z"/><circle cx="9" cy="20" r="1.4"/><circle cx="16" cy="20" r="1.4"/><path d="M3 4h2l1 3"/>',
        heal: '<path d="M12 20s-7-4.6-7-9.3A3.7 3.7 0 0 1 12 8a3.7 3.7 0 0 1 7 2.7C19 15.4 12 20 12 20z"/>',
        join: '<circle cx="9" cy="8" r="3.2"/><path d="M3 20a6 6 0 0 1 12 0"/><path d="M18 8v6M15 11h6"/>',
        deal: '<path d="M8 12l3-3 2.5 2.5L16 9"/><path d="M3 11l4-4 3 3"/><path d="M21 11l-4-4-2.5 2.5"/><path d="M8 12l4 4 3-3"/>',
    };
    $: icon = (() => {
        const t = String(title1 || '').toLowerCase();
        if (t.includes('обмен')) return ICONS.trade;
        if (t.includes('покуп') || t.includes('прода')) return ICONS.buy;
        if (t.includes('леч') || t.includes('помощ')) return ICONS.heal;
        if (t.includes('вступ') || t.includes('приглаш') || t.includes('семь')) return ICONS.join;
        return ICONS.deal;
    })();
</script>

{#if show}
<div class="lco" transition:fly={{ y: 26, duration: 300 }}>
    <div class="lco-top">
        <span class="lco-ico">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round">{@html icon}</svg>
        </span>
        <span class="lco-txt">
            <span class="lco-kick">Предложение</span>
            {#if title1}<span class="lco-head">{title1}</span>{/if}
            {#if desc1}<span class="lco-desc">{@html desc1}</span>{/if}
        </span>
    </div>

    <div class="lco-bar"><i style="width:{(left / LIFE) * 100}%"></i></div>

    <div class="lco-keys">
        <span class="lco-key ok"><b>Y</b> Принять</span>
        <span class="lco-key no"><b>N</b> Отказаться</span>
        <span class="lco-left">{Math.ceil(left)} с</span>
    </div>
</div>
{/if}

<style>
    .lco {
        position: fixed; left: 50%; bottom: 9vh; transform: translateX(-50%);
        z-index: 60; width: 42vh; box-sizing: border-box;
        padding: 1.5vh 1.7vh 1.3vh;
        border-radius: 1.5vh;
        background: linear-gradient(135deg, rgba(30, 23, 12, 0.97), rgba(14, 11, 8, 0.95));
        border: 1px solid rgba(231, 174, 63, 0.42);
        box-shadow: 0 1.6vh 4.4vh rgba(0, 0, 0, 0.6), 0 0 2.6vh rgba(231, 174, 63, 0.12);
        font-family: 'Manrope', 'Gilroy', sans-serif;
        pointer-events: none;
    }
    .lco-top { display: flex; align-items: flex-start; gap: 1.2vh; }
    .lco-ico {
        flex-shrink: 0; width: 4vh; height: 4vh; border-radius: 1.1vh;
        display: flex; align-items: center; justify-content: center;
        background: linear-gradient(135deg, #f0c863, #c8852f); color: #241a06;
        box-shadow: 0 0.6vh 1.8vh rgba(224, 168, 62, 0.32);
    }
    .lco-ico svg { width: 2.2vh; height: 2.2vh; }
    .lco-txt { display: flex; flex-direction: column; gap: 0.3vh; min-width: 0; }
    .lco-kick {
        font-size: 0.9vh; font-weight: 700; letter-spacing: 0.2em;
        text-transform: uppercase; color: #e7ae3f;
    }
    .lco-head { font-size: 1.7vh; font-weight: 800; color: #fff; line-height: 1.15; }
    .lco-desc {
        font-size: 1.3vh; font-weight: 600; line-height: 1.4;
        color: rgba(243, 234, 214, 0.85); word-break: break-word;
    }

    .lco-bar {
        margin: 1.2vh 0 1vh; height: 3px; border-radius: 2px;
        background: rgba(255, 255, 255, 0.1); overflow: hidden;
    }
    .lco-bar i {
        display: block; height: 100%; border-radius: 2px;
        background: linear-gradient(90deg, #c8852f, #f0c863);
        transition: width 0.1s linear;
    }

    .lco-keys { display: flex; align-items: center; gap: 1.2vh; }
    .lco-key {
        display: flex; align-items: center; gap: 0.6vh;
        font-size: 1.2vh; font-weight: 700; color: rgba(255, 255, 255, 0.72);
    }
    .lco-key b {
        display: inline-flex; align-items: center; justify-content: center;
        min-width: 2.2vh; height: 2.2vh; padding: 0 0.5vh; border-radius: 0.6vh;
        font-size: 1.1vh; font-weight: 800;
        background: rgba(255, 255, 255, 0.08); border: 1px solid rgba(255, 255, 255, 0.14);
        color: #fff;
    }
    .lco-key.ok b { background: linear-gradient(135deg, #f0c863, #c8852f); border-color: #f0c863; color: #241a06; }
    .lco-key.no b { border-color: rgba(224, 106, 85, 0.5); color: #e06a55; }
    .lco-left { margin-left: auto; font-size: 1.1vh; font-weight: 700; color: rgba(255, 255, 255, 0.38); }
</style>
